/**
 * Display helpers for showing internal 0–10 scores on a 0–100 scale.
 * Display-only: scoring, storage and all thresholds stay 0–10. Never feed the
 * output of these back into band/colour/width logic.
 */

/** Internal 0–10 score → its 0–100 display integer (5.7 → 57). */
export function scoreOutOf100(score: number): number {
  return Math.max(0, Math.min(100, Math.round(score * 10)));
}

/** Mirror of the old "5.7/10" string: "57/100". */
export function scoreOutOf100Label(score: number): string {
  return `${scoreOutOf100(score)}/100`;
}
